import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { Button } from "@similarweb/ui-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const i18n = i18nFilter();

const ContentModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 15px 12px rgba(colorspalettes.black[0], 0.22), 0 19px 38px rgba(colorspalettes.black[0], 0.3);
`;

const ButtonStyle = styled(Button)`
    align-self: end;
    margin-right: 16px;
`;
const TitleStyle = styled.span`
    margin-bottom: 36px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;
const SubtitleStyle = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[400])}
    width: 352px;
    margin-bottom: 24px;
`;

const RedTipMessage = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[400])}
`;
const RedTipMessageWrapper = styled.div`
    padding: 16px;
    width: 320px;
    min-height: 20px;
    border: 1px solid ${colorsPalettes.red[300]};
    border-radius: 4px;
    background: ${colorsPalettes.red[100]};
    margin-bottom: 24px;
`;

interface ILongSegmentRulesErrorModal {
    isOpen: boolean;
    onCloseModal: (isOpen: boolean) => void;
    percentageChangeFromLimitCharacters: string;
}

export const LongSegmentRulesErrorModal: FC<ILongSegmentRulesErrorModal> = ({
    isOpen,
    onCloseModal,
    percentageChangeFromLimitCharacters,
}) => {
    const titleText = i18n("long.segment.rules.error.modal.title");
    const subtitleText = i18n("long.segment.rules.error.modal.subtitle");
    const tipErrorText = i18n("long.segment.rules.error.modal.tip.error", {
        percentageChange: percentageChangeFromLimitCharacters,
    });
    const buttonText = i18n("long.segment.rules.error.modal.button");

    const onButtonClick = () => {
        onCloseModal(false);
    };

    const ModalStyles = {
        content: {
            width: "400px",
            padding: "20px 0 16px 24px",
            minHeight: "292px",
        },
    };

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={ModalStyles}
            data-automation="LongSegmentRulesErrorModal"
        >
            <ContentModalWrapper>
                <TitleStyle>{titleText}</TitleStyle>
                <SubtitleStyle>{subtitleText}</SubtitleStyle>
                <RedTipMessageWrapper>
                    <RedTipMessage>{tipErrorText}</RedTipMessage>
                </RedTipMessageWrapper>
                <ButtonStyle
                    type="warning"
                    onClick={onButtonClick}
                >
                    {buttonText}
                </ButtonStyle>
            </ContentModalWrapper>
        </ProModal>
    );
};
